// EmojiProperties.jsx
import React from "react";
import { Link } from 'gatsby-plugin-react-i18next';

import "./emoji-properties.css";

const EmojiProperties = ({ properties }) => {
  return (
    <div className="mt-3 mb-3">
      <div className="container max-width">
        {properties.map((property, index) => (
          <div key={index} className={`row ${property.bubble ? "" : "mb-4"}`}>
            <div className={`col-auto custom-title px-0 ${property.bubble ? "pt-2" : ""}`}>
              <span className="w-100">{property.title}</span>
            </div>
            <div className={`col px-0 value-col ${property.valueClass || ""}`}>
              {Array.isArray(property.values) ? (
                property.values.map((value, valueIndex) => (
                  typeof value === "object" ? (
                    value.link ? (
                      <Link to={value.link}>
                        <div key={valueIndex} className={`${property.bubble ? "bubble-text mb-3" : ""} ${property.valueClass || ""}`}>
                          {value.text}
                        </div>
                      </Link>
                    ) : (
                      <div key={valueIndex} className={`${property.bubble ? "bubble-text mb-3" : ""} ${property.valueClass || ""}`}>
                        {value.text}
                      </div>
                    )
                  ) : (
                    <div>{value}</div>
                  )
                ))
              ) : (
                <div className={`${property.bubble ? "bubble-text mb-3" : ""} ${property.valueClass || ""}`}>
                  <div>{property.values}</div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmojiProperties;
